<div class="form-container task-form">
    <div class="action-btn">
        {{ 'Task' | translate }}
        <!-- <a class="btn btn-sm btn-circle btn-outline-primary w-auto" routerLink="create">
        {{ 'Assign' | translate }}
      </a> -->
    </div>
    <form [formGroup]="taskForm" (ngSubmit)="onFormSubmit()">
        <div>
            <div *ngIf="!inAnnote" class="form-group">
                <select formControlName="annotation" class="form-control" #annotList>
					<option value="" disabled selected>{{'Select Annotation' | translate}}</option>
					<option *ngFor="let annotation of annotations; trackById" value="{{annotation.id}}">{{annotation.name}}
					</option>
				</select>
                <div *ngIf="annotList.selectedIndex === 0" class="text-danger">{{'Annotation is required' | translate}}</div>
            </div>
            <div class="form-group">
                <input formControlName="name" type="text" class="form-control" placeholder="{{ 'Task Name' | translate }}">
                <div *ngIf="formName?.invalid" class="text-danger">{{'Name is required' | translate}}</div>
            </div>
            <div class="form-group">
                <textarea formControlName="description" class="form-control" placeholder="{{ 'Description' | translate }}"></textarea>
                <div *ngIf="formDescription?.invalid" class="text-danger">{{'Description is required' | translate}}</div>
            </div>
            <div class="form-group">
                <input formControlName="fixing_date" type="date" class="form-control" placeholder="{{ 'Est. Fixing Date' | translate }}">
                <div *ngIf="!formDate?.value" class="text-danger">{{'Date is required' | translate}}</div>
            </div>
            <div class="form-group">
                <input formControlName="assignee" type="text" class="form-control" [value]="assigneeEmail" placeholder="{{ 'Assign user. Search by email' | translate }}" (keyup)="searchUser($event)">
                <div #autoComplete class="auto-complete">
                    <ul class="list-group">
                        <li *ngFor="let user of userSelection; trackById" (click)="selectedUser(user.item)" class="list-group-item">
                            {{ user.item.email }}</li>
                    </ul>
                </div>
                <div *ngIf="formAssignee?.invalid" class="text-danger">{{'Assignee is required' | translate}}</div>
            </div>
        </div>
        <div style="display: none">
            <button type="submit">{{'Hidden submit button so that the form will emit (ngSubmit)' | translate}}</button>
        </div>
    </form>
</div>